import Http from '@/libs/axios'
import moment from 'moment'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    roleSelectOption: [],
    permissionModules: []
  },
  getters: {
    roleSelectOption: state => {
      return state.roleSelectOption
    },
    permissionModules: state => {
      return state.permissionModules
    }
  },
  mutations: {
    SET_ROLE_SELECT_OPTION(state, items) {
      let listOfObjects = Object.keys(items).map((key) => {
        return items[key]
      })

      listOfObjects.map((index, item) => {
        return { value: index, text: item }
      })

      state.roleSelectOption = listOfObjects
    },

    SET_PERMISSION_MODULES(state, items){
      state.permissionModules = items
    }
  },
  actions: {
    getRoleSelectOption({commit}){
      return new Promise((resolve, reject) => {
        Http.get('role-permission/role-select-option').then(response => {
            commit('SET_ROLE_SELECT_OPTION', response.data)
            resolve()
        }).catch(error => reject(error))
      })
    },
  },
}
